import { Alert, AlertIcon, Card, CardBody, VStack } from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import Loader from "../../utils/Loader/Loader";
import Layout from "../Layout/Layout";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { SettingContext } from "../Settings/Reducer/SettingProvider";

export default function AgencyWrapper({ children }) {
  const { state, loading } = useContext(SettingContext);
  const agency = useContext(AgencyContext);
  const { getAgencies } = agency;

  useEffect(() => {
    getAgencies();
  }, []);

  if (loading && agency.loading) return <Loader />;

  return (
    <Layout>
      <VStack h="100%" spacing={2} borderRadius="md">
        {!state?.credits?.agency ? (
          <Card variant={"elevated"} width={"100%"} my={12}>
            <CardBody>
              <Alert status="info">
                <AlertIcon /> Please upgrade to one of the Agency packs to enable this section.
              </Alert>
            </CardBody>
          </Card>
        ) : (
          children
        )}
      </VStack>
    </Layout>
  );
}
